import styled from 'styled-components';

import colors from '../../../../styles/colors';

const Section = styled.section`
  background-color: ${colors.shades.secondary10};
  border-bottom: 1px solid ${colors.shades.secondary7};
  padding: 20px 40px 25px;
`;

const SectionTitle = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  margin-bottom: 15px;
  text-transform: uppercase;
  color: ${colors.shades.secondary3};
`;

export {
  Section,
  SectionTitle,
};
